export const AllowedGroupsList = [
  'Warehouse User Admin',
  'Warehouse',
  'Warehouse Inbound Agent',
  'Warehouse Picker',
  'Warehouse Return Agent',
  'Warehouse Scanner',
  'Warehouse Stock Controller',
];
